import { useCallback } from 'react';
import { Button, Menu, MenuItem, Popover } from '@blueprintjs/core';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { AuthState } from '../../views/auth/types';
import { doLogout } from '../../views/auth/reducer';

const LoginHeaderButton = () => {
  const dispatch = useAppDispatch();
  const state: AuthState = useAppSelector((state) => state.auth);

  const logout = useCallback(() => {
    dispatch(doLogout());
    window.location.reload();
  }, [dispatch]);

  const buildMenu = useCallback(() => {
    return (
      <Menu>
        <MenuItem icon="log-out" onClick={() => logout()} text="Logoff" />
      </Menu>
    );
  }, [logout]);

  return (
    <Popover content={buildMenu()} placement="bottom">
      <Button minimal icon="user" text={state.profile?.username} />
    </Popover>
  );
};

export default LoginHeaderButton;
